<sc-modal>
  <div class="flex justify-between mb-6">
    <h3 class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline">
      {{ 'components.unpaidInvoiceInfoModal.label' | scTranslate | async }}
    </h3>
    <sc-button variant="text" [padding]="false" (click)="close(false)">
      <sc-svg name="cross" size="w-8 h-8"></sc-svg>
    </sc-button>
  </div>
  <p class="font-semibold mb-1 tracking-wide">
    {{ 'components.unpaidInvoiceInfoModal.title' | scTranslate | async }}
  </p>
  <p class="text-[#000] tracking-wide">
    {{ 'components.unpaidInvoiceInfoModal.subTitle1' | scTranslate | async }}
  </p>
  <p class="text-[#000] mt-3 mb-16 tracking-wide">
    {{ 'components.unpaidInvoiceInfoModal.subTitle2' | scTranslate | async }}
  </p>
  <sc-modal-footer>
    <sc-button variant="primary" (click)="close(true)">
      <span>
        {{ 'components.unpaidInvoiceInfoModal.goToInvoicesBtn' | scTranslate | async }}
      </span>
    </sc-button>
  </sc-modal-footer>
</sc-modal>
